import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const HeroSectionLayout = ({
  pageType, children
}) => {
  return (
    <>
      {pageType == 'tac_landing' ? (
        <div className={clsx(
          'relative px-2 py-14 pt-16 md:py-6 md:px-16 lg:px-[88px] xl:px-44 2xl:px-60',
          'lg:min-h-[750px] flex flex-col justify-center',
        )}>
          <div className="flex flex-col gap-11 justify-between items-center max-w-8xl mx-auto text-center lg:text-left">
            {children}
          </div>
        </div>
      ) : (
        <div className={clsx(
          'relative px-2 py-14 pt-16 md:py-12 md:px-16 lg:px-[88px] xl:px-44 2xl:px-60',
          pageType == 'lead' || pageType == 'registration' ? '' : 'lg:pb-[204px]',
          pageType == 'registration' && 'lg:min-h-[750px] flex flex-col justify-center',
        )}>
          <div className={clsx(
            'flex flex-col gap-11 lg:gap-28 justify-between items-center max-w-8xl mx-auto text-center lg:text-left',
            pageType == 'lead' || pageType == 'registration' ? '' : 'lg:flex-row',
          )}>
            {children}
          </div>
        </div>
      )}
    </>
  );
};

HeroSectionLayout.propTypes = {
  pageType: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.node)
};

export default HeroSectionLayout;
